import React from "react";
import "./css/ChartLoader.css";

const PieChartLoader = () => {
  return (
    <div className="pie-skeleton">
      <div className="pie-skeleton-circle" />
      <div className="pie-skeleton-labels">
        <div className="pie-skeleton-label" />
        <div className="pie-skeleton-label" />
        <div className="pie-skeleton-label" />
        <div className="pie-skeleton-label" />
      </div>
    </div>
  );
};

export default PieChartLoader;
